import React from "react";
import { FormikProps, withFormik } from "formik";
import { FormStack } from "../components/FormStack/FormStack";
import {
  IntegrationFeatureProps,
  IntegrationGetWorkerListParameter,
} from "../components/Integration/IntegrationsFeatureParameter";
import {
  ChakraReactSelectField,
  SelectOption,
} from "../components/fields/SelectField/ChakraReactSelectField";
import { SingleValue } from "chakra-react-select";

interface GetIntegrationWorkerListParameterFormValues
  extends IntegrationGetWorkerListParameter {}

interface GetIntegrationWorkerListParameterFormProps
  extends IntegrationFeatureProps {
  types: string[] | null;
  typesIsLoading: boolean;
}

const InnerForm = ({
  setFieldValue,
  setFieldFeatureValue,
  types,
  typesIsLoading,
}: GetIntegrationWorkerListParameterFormProps &
  FormikProps<GetIntegrationWorkerListParameterFormValues>) => {
  return (
    <FormStack>
      <ChakraReactSelectField
        horizontal
        label="List Type Id"
        name="listTypeId"
        selectedOptionColor="blue"
        className="relative-listbox"
        isLoading={typesIsLoading}
        options={
          types?.map((data) => {
            return {
              label: data,
              value: data,
            };
          }) || []
        }
        onChange={(e) => {
          const value = (e as SingleValue<SelectOption>)?.value;
          setFieldValue("listTypeId", value);
          setFieldFeatureValue("listTypeId", value);
        }}
      />
    </FormStack>
  );
};

export const GetIntegrationWorkerListParameterForm = withFormik<
  GetIntegrationWorkerListParameterFormProps,
  GetIntegrationWorkerListParameterFormValues
>({
  mapPropsToValues: ({ feature }) => {
    if (!feature.parameter) {
      feature.parameter = {};
    }
    return { listTypeId: feature.parameter?.listTypeId };
  },
  handleSubmit: async (values, { props, setFieldError }) => {},
  validateOnBlur: false,
  validateOnMount: false,
  validateOnChange: false,
})(InnerForm);
